/* ApexBrew PDP, Rosabella style (Coffee Armor): scroll links, peek gallery, zoom, bundle cards, sticky bar, videos. */
(function () {
  'use strict';
  var d = document, w = window;
  var reduce = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  function all(sel, root) { return Array.prototype.slice.call((root || d).querySelectorAll(sel)); }

  /* Top bar height -> --top-h (scroll offsets, sticky gallery and guarantee panel). Only counts while the bar is
     sticky: on phones it scrolls away with the page. */
  var topBar = d.querySelector('.pdp-sec-top');
  function topH() { return topBar && getComputedStyle(topBar).position === 'sticky' ? topBar.offsetHeight : 0; }
  function setTopH() { d.documentElement.style.setProperty('--top-h', topH() + 'px'); }
  setTopH();
  w.addEventListener('resize', setTopH, { passive: true });

  /* In-page links (top bar, sticky bar): smooth scroll, landing below the sticky top bar. */
  d.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a) return;
    var id = decodeURIComponent(a.getAttribute('href').slice(1));
    var el = id && d.getElementById(id);
    if (!el) return;
    e.preventDefault();
    var y = el.getBoundingClientRect().top + w.pageYOffset - topH() - 10;
    w.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
  });

  /* Gallery: peek carousel on native scroll-snap; thumbnails/dots and arrows follow it. */
  all('[data-rb-gal]').forEach(function (g) {
    var track = g.querySelector('[data-gal-track]');
    if (!track) return;
    var slides = all('.rb-slide', track);
    var marks = all('[data-gal-go]', g);
    var cur = 0;
    function pad() { return parseFloat(getComputedStyle(track).paddingLeft) || 0; }
    function offset(i) { return track.scrollLeft + slides[i].getBoundingClientRect().left - track.getBoundingClientRect().left - pad(); }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: offset(i), behavior: reduce ? 'auto' : 'smooth' });
    }
    function mark(i) {
      if (i === cur) return;
      cur = i;
      marks.forEach(function (m) { m.setAttribute('aria-current', String(+m.getAttribute('data-gal-go') === i)); });
    }
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var left = track.getBoundingClientRect().left + pad(), best = 0, bestD = Infinity;
        slides.forEach(function (s, i) { var dd = Math.abs(s.getBoundingClientRect().left - left); if (dd < bestD) { bestD = dd; best = i; } });
        mark(best);
      });
    }, { passive: true });
    var prev = g.querySelector('[data-gal-prev]');
    var next = g.querySelector('[data-gal-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    marks.forEach(function (m) { m.addEventListener('click', function () { go(+m.getAttribute('data-gal-go')); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
    });
  });

  /* Zoom: buttons with data-zoom open the full image in a modal dialog. */
  var lb = d.querySelector('[data-rb-lb]');
  if (lb && typeof lb.showModal === 'function') {
    var lbImg = lb.querySelector('img');
    d.addEventListener('click', function (e) {
      var z = e.target.closest ? e.target.closest('[data-zoom]') : null;
      if (z) {
        lbImg.src = z.getAttribute('data-zoom');
        lbImg.alt = z.getAttribute('data-zoom-alt') || '';
        lb.showModal();
        return;
      }
      if (e.target === lb || (e.target.closest && e.target.closest('[data-lb-close]'))) lb.close();
    });
    lb.addEventListener('close', function () { lbImg.removeAttribute('src'); });
  } else {
    all('[data-zoom]').forEach(function (z) { z.hidden = true; });
  }

  /* Timeline folds: always open on desktop (3 columns side by side). */
  if (w.matchMedia && w.matchMedia('(min-width: 980px)').matches) all('.rb-tl__fold').forEach(function (f) { f.open = true; });

  /* Bundle cards: one radio group per buy box; picking a card shows its details panel in both boxes. */
  var boxes = all('[data-rb-bb]');
  function select(n, keepEl) {
    var before = keepEl ? keepEl.getBoundingClientRect().top : 0;
    boxes.forEach(function (box) {
      all('[data-rb-card]', box).forEach(function (c) {
        var on = c.getAttribute('data-tier') === String(n);
        c.classList.toggle('is-on', on);
        c.setAttribute('aria-checked', String(on));
        c.tabIndex = on ? 0 : -1;
      });
      all('[data-rb-detail]', box).forEach(function (p) { p.hidden = p.getAttribute('data-tier') !== String(n); });
    });
    if (keepEl) {
      var dy = keepEl.getBoundingClientRect().top - before;
      if (Math.abs(dy) > 1) w.scrollBy(0, dy);
    }
  }
  boxes.forEach(function (box) {
    var cards = all('[data-rb-card]', box);
    cards.forEach(function (c, i) {
      c.addEventListener('click', function () { select(c.getAttribute('data-tier'), c); });
      c.addEventListener('keydown', function (e) {
        var j = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % cards.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + cards.length) % cards.length;
        if (j < 0) return;
        e.preventDefault();
        select(cards[j].getAttribute('data-tier'), cards[j]);
        cards[j].focus();
      });
    });
  });
  /* ?variant=<id> (the advertorial's tier links) preselects that bundle. */
  var vq = (location.search.match(/[?&]variant=(\d+)/) || [])[1];
  if (vq) {
    var hit = d.querySelector('[data-rb-card][data-variant="' + vq + '"]');
    if (hit) select(hit.getAttribute('data-tier'));
  }

  /* Sticky bar: visible once past the gallery (or 550px down); hidden while any buy box is on screen. */
  var sticky = d.querySelector('[data-pdp-sticky]');
  if (sticky) {
    var gal = d.querySelector('[data-rb-gal]');
    var stickyBtn = sticky.querySelector('a');
    var boxOn = boxes.map(function () { return false; });
    var shown = false;
    var update = function () {
      var past = w.pageYOffset > 550 || (gal ? gal.getBoundingClientRect().bottom < 0 : false);
      var show = past && !boxOn.some(Boolean);
      if (show === shown) return;
      shown = show;
      sticky.classList.toggle('is-on', show);
      sticky.setAttribute('aria-hidden', String(!show));
      if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
    };
    if ('IntersectionObserver' in w && boxes.length) {
      var bio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { boxOn[boxes.indexOf(en.target)] = en.isIntersecting; });
        update();
      }, { rootMargin: '0px 0px -76px 0px' });
      boxes.forEach(function (b) { bio.observe(b); });
    }
    var sraf = 0;
    w.addEventListener('scroll', function () {
      if (sraf) return;
      sraf = requestAnimationFrame(function () { sraf = 0; update(); });
    }, { passive: true });
    update();
  }

  /* Videos: poster set ~1200px before a video scrolls near; muted playback while 35%+ is on screen, starting after
     the page has loaded. Reduced motion or data saver: the poster/still only. */
  var vids = all('video[data-pdp-video]');
  if (vids.length) {
    var loaded = d.readyState === 'complete';
    var poster = function (v) { var p = v.getAttribute('data-poster'); if (p && !v.getAttribute('poster')) v.setAttribute('poster', p); };
    var play = function (v) {
      if (reduce || saveData) return;
      v.muted = true;
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {});
    };
    if (!('IntersectionObserver' in w)) {
      vids.forEach(poster);
    } else {
      var near = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { poster(en.target); near.unobserve(en.target); } });
      }, { rootMargin: '1200px 0px' });
      var vis = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          v._rbVis = en.isIntersecting;
          if (en.isIntersecting) { if (loaded) play(v); } else { v.pause(); }
        });
      }, { threshold: 0.35 });
      vids.forEach(function (v) { v.muted = true; near.observe(v); vis.observe(v); });
      if (!loaded) {
        w.addEventListener('load', function () {
          loaded = true;
          vids.forEach(function (v) { if (v._rbVis) play(v); });
        });
      }
    }
  }
})();
